/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wd_ContributorsInputs */

const en_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contributors`)
};

const ar_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المساهمون`)
};

const bn_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কন্ট্রিবিউটর`)
};

const de_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitwirkende`)
};

const es_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colaboradores`)
};

const fr_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contributeurs`)
};

const pt_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colaboradores`)
};

const zh_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贡献者`)
};

const tr_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katkıda Bulunanlar`)
};

const ru_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Участники`)
};

const pl_wd_contributors = /** @type {(inputs: Wd_ContributorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Współtwórcy`)
};

/**
* | output |
* | --- |
* | "Contributors" |
*
* @param {Wd_ContributorsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const wd_contributors = /** @type {((inputs?: Wd_ContributorsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_ContributorsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_wd_contributors(inputs)
	if (locale === "bn") return bn_wd_contributors(inputs)
	if (locale === "de") return de_wd_contributors(inputs)
	if (locale === "es") return es_wd_contributors(inputs)
	if (locale === "fr") return fr_wd_contributors(inputs)
	if (locale === "pt") return pt_wd_contributors(inputs)
	if (locale === "zh") return zh_wd_contributors(inputs)
	if (locale === "tr") return tr_wd_contributors(inputs)
	if (locale === "ru") return ru_wd_contributors(inputs)
	if (locale === "pl") return pl_wd_contributors(inputs)
	return en_wd_contributors(inputs)
});